import type { Tokens } from '../../styled'
import { type UdsTokens, useUdsToken as useUdsTokenFromUdsUi } from '@sunwebgroup/uds-ui/utils'
import { useTheme } from 'styled-components'

export function useToken<T>(tokenName: keyof Tokens): T {
  const theme = useTheme()
  return theme.tokens[tokenName] as T
}

/** @deprecated Import `useUdsToken` from `@sunwebgroup/uds-ui/providers` instead. */
export function useUdsToken<T>(tokenName: keyof UdsTokens): T {
  return useUdsTokenFromUdsUi<T>(tokenName)
}
